import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { createModal } from '../../components/generic/Modal';
import { useCloneParticipantDocumentMutation } from '../../graphql/hooks/useCloneParticipantDocumentMutation';
import { useAppContext } from '../../hooks/useAppContext';

interface Props {
  participantId: string;
  participantDocumentId: string;
}

export const ParticipantDocumentCloneModal = createModal<Props>((props) => {
  const { participantId, participantDocumentId, modal } = props;
  const { organization, successToast, errorToast } = useAppContext();
  const { hide, remove, visible } = modal;

  const mutation = useCloneParticipantDocumentMutation();

  const onClone = React.useCallback(async () => {
    await mutation
      .mutateAsync({
        organizationId: organization.id,
        participantId,
        participantDocumentId,
      })
      .then(async () => {
        successToast('Document cloned successfully');
        hide();
      })
      .catch((err) => {
        errorToast(`Error cloning document: ${err.message}`);
      });
  }, [
    mutation,
    organization.id,
    participantId,
    participantDocumentId,
    successToast,
    hide,
    errorToast,
  ]);

  return (
    <ChakraV3.Dialog.Root open={visible} onOpenChange={hide} onExitComplete={remove}>
      <ChakraV3.Dialog.Backdrop />
      <ChakraV3.Dialog.Positioner>
        <ChakraV3.Dialog.Content>
          <ChakraV3.DialogTitleSubtitle title='Do you want to clone this document?' />
          <ChakraV3.Dialog.Footer>
            <ChakraV3.Button onClick={hide} size='sm' variant='subtle'>
              Close
            </ChakraV3.Button>
            <ChakraV3.Button
              onClick={onClone}
              colorPalette='brand'
              size='sm'
              loading={mutation.isLoading}
            >
              Clone
            </ChakraV3.Button>
          </ChakraV3.Dialog.Footer>
        </ChakraV3.Dialog.Content>
      </ChakraV3.Dialog.Positioner>
    </ChakraV3.Dialog.Root>
  );
});
